var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.TextInput,_vm._b({attrs:{"value":_vm.value,"type":_vm.type},on:{"input":function($event){return _vm.$emit('input', $event)}}},'TextInput',_setup.attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }